import React from 'react';
import { CloseIcon } from './icons';

const ErrorModal = ({ isOpen, onClose, title, message, details }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-dark-surface border border-dark-border rounded-lg w-full max-w-md max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-dark-border">
          <h3 className="text-lg font-semibold text-dark-text-primary">{title}</h3>
          <button 
            onClick={onClose}
            className="p-1 rounded-md text-dark-text-secondary hover:bg-dark-bg"
          >
            <CloseIcon className="w-5 h-5" />
          </button>
        </div>
        
        <div className="p-4 overflow-y-auto flex-grow">
          <p className="text-dark-text-primary mb-4">{message}</p>
          
          {details && (
            <div className="mt-4">
              <h4 className="font-medium text-dark-text-primary mb-2">Details:</h4>
              <div className="bg-dark-bg p-3 rounded-md border border-dark-border">
                {typeof details === 'object' ? (
                  <div className="text-sm text-dark-text-secondary">
                    {details.message && (
                      <div className="mb-2">
                        <strong className="text-dark-text-primary">Message:</strong>
                        <div className="ml-2">{details.message}</div>
                      </div>
                    )}
                    {details.prompt && (
                      <div className="mb-2">
                        <strong className="text-dark-text-primary">Prompt:</strong>
                        <div className="ml-2">{details.prompt}</div>
                      </div>
                    )}
                    {details.stack && (
                      <div>
                        <strong className="text-dark-text-primary">Stack Trace:</strong>
                        <div className="ml-2 font-mono text-xs whitespace-pre-wrap">{details.stack}</div>
                      </div>
                    )}
                  </div>
                ) : (
                  <pre className="text-sm text-dark-text-secondary overflow-x-auto whitespace-pre-wrap">
                    {details}
                  </pre>
                )}
              </div>
            </div>
          )}
        </div>
        
        <div className="p-4 border-t border-dark-border">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 bg-brand-primary text-white rounded-md hover:bg-brand-primary/90 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;